import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Self-hosted fonts first, so index.css and Tailwind find their families.
import './fonts';
import './index.css';
import { configureAmplify } from './config/amplify';
import { API_BASE_URL } from './config/api';
import { installSessionExpiryInterceptor } from './auth/sessionExpiry';
import { installCatalogInvalidation } from './services/catalogCache';
// Catches Android's install prompt early, for the vault's "Add to home screen".
import './utils/installPrompt';
import posthog, { isAnalyticsEnabled } from './config/posthog';
import { PostHogProvider } from 'posthog-js/react';

// Configure Amplify before rendering the app
configureAmplify();
// A 401 SESSION_EXPIRED from the API signs the user out (#284).
installSessionExpiryInterceptor(API_BASE_URL);
// Any write to the API drops the catalog kept across workspace views (#282).
installCatalogInvalidation(API_BASE_URL);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* App renders its own AuthProvider: a second one here ran every auth
        check twice. */}
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </React.StrictMode>
);

// Touch the flag so bundlers do not tree-shake the init side-effect away.
void isAnalyticsEnabled;
